import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/system-logs')({
  component: AdminSystemLogsRoute,
});

function AdminSystemLogsRoute() {
  return <Outlet />;
}
